import { render, staticRenderFns } from "./SimBajaIndividualBase.vue?vue&type=template&id=29e57f12&"
import script from "./SimBajaIndividualBase.vue?vue&type=script&lang=ts&"
export * from "./SimBajaIndividualBase.vue?vue&type=script&lang=ts&"
import style0 from "./SimBajaIndividualBase.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('29e57f12', component.options)
    } else {
      api.reload('29e57f12', component.options)
    }
    module.hot.accept("./SimBajaIndividualBase.vue?vue&type=template&id=29e57f12&", function () {
      api.rerender('29e57f12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SimBajaIndividual/SimBajaIndividualBase.vue"
export default component.exports